var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[(_vm.getOverlayVisibilityStatus)?_c('VueOverlay'):_vm._e(),_c('router-view'),_c('BrandErrorModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }